import { ChatFilterState } from "../interfaces/chats";
import { IDateFilter } from "../types/commonTypes";
import { DateFilterEnum } from "./enums";
import moment from "moment";

export const DEFAULT_LOCALE = "en" as const;
export const ALLOWED_LOCALE = [DEFAULT_LOCALE] as const;
export type iAllowedLocale = (typeof ALLOWED_LOCALE)[number];
export const DEFAULT_API_ERROR = {
	statusCode: 0,
	message: "something went wrong!",
};
// fcm_token_saved
export const FIREBASE_TOKEN_SYNC_STATUS = "firebase_token_sync_status";
export const CORPORATE_EVENT_ATTACHMENTS_PATH = "corporate/events/attachments";
export const MAX_UNREAD_MESSAGE_COUNT = 99;
export const MAX_SELECTABLE_PHOTOS = 4;
export const MAX_FILE_SIZE_FOR_PHOTO_LIBRARY = 10 * 1024 * 1024;
export const ALLOWED_IMAGE_FILE_TYPES = ["image/png", "image/jpeg", "image/jpg"];
export const CURRENCY = 'AED';
export const REMOVE_SECONDS_REGEX = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
export const DEFAULT_PAGE_LIMIT_MESSAGING = 10;
export const MAX_WIDTH_FOR_CHATS_LIST_PAGE = 1070;
export const COMMOM_MAX_WIDTH = 1023.98;

export const INITIAL_CHAT_FILTERS: ChatFilterState = {
  orderId: '',
  eventDateStart: null,
  eventDateEnd: null,
  createdDateStart: null,
  createdDateEnd: null,
  vendorEventStatus: [],
  eventType: '',
};

export const DATE_FILTERS: IDateFilter[] = [
	{
		id: DateFilterEnum.ALL_TIME,
		label: "All time",
		startDate: new Date(0), // Epoch time for "all time"
		endDate: new Date(),
	},
	{
		id: DateFilterEnum.LAST_30_DAYS,
		label: "Last 30 days",
		startDate: moment().subtract(30, "days").toDate(),
		endDate: new Date(),
	},
	{
		id: DateFilterEnum.LAST_3_MONTHS,
		label: "Last 3 months",
		startDate: moment().subtract(3, "months").toDate(),
		endDate: new Date(),
	},
	{
		id: DateFilterEnum.LAST_6_MONTHS,
		label: "Last 6 months",
		startDate: moment().subtract(6, "months").toDate(),
		endDate: new Date(),
	},
	{
		id: DateFilterEnum.LAST_YEAR,
		label: "Last year",
		startDate: moment().subtract(1, "year").toDate(),
		endDate: new Date(),
	},
	{
		id: DateFilterEnum.CUSTOM,
		label: "Custom range",
		startDate: moment().subtract(6, "months").toDate(),
		endDate: new Date(),
	},
];

export const SENDBIRD_CUSTOM_MESSAGES = {
  AUDIO: 'Sent you an audio message.',
  IMAGE: 'Sent you an image.',
  FILE: 'Sent you a file.',
};